import { Suspense, useEffect, useState } from 'react';

import LegacyContainer from '@/container/legacy';
import NavReshuffleContainer from '@/container/nav-reshuffle';
import { useShell } from '@/context';
import useContainer from '@/core/container';
import { ProductNavReshuffleProvider } from '@/core/product-nav-reshuffle';
import { ProgressProvider } from '@/context/progress';
import CookiePolicy from '@/cookie-policy/CookiePolicy';
import SSOAuthModal from '@/components/sso-auth-modal/SSOAuthModal.component';
import LiveChat from '@/container/livechat/LiveChat.component';
import AIChatbot from '@/components/ai-chatbot/AIChatbot/AIChatbot.component';

export default function Container(): JSX.Element {
  const { isLoading, betaVersion, useBeta } = useContainer();
  const shell = useShell();
  const [isCookiePolicyModalClosed, setIsCookiePolicyModalClosed] = useState<boolean>(false);

  const isNavReshuffle = betaVersion && useBeta;

  const cookiePolicyHandler = (_?: boolean): void =>
    setIsCookiePolicyModalClosed(true);

  useEffect(() => {
    if (!isLoading) {
      const tracking = shell.getPlugin('tracking');
      tracking.waitForConfig().then(() => {
        if (isNavReshuffle) {
          tracking.trackMVTest({
            test: '[product-navigation-reshuffle]',
            waveId: 2,
            creation: '[full-services_v3]',
          });
        }
      });
      if (isNavReshuffle) {
        shell.getPlugin('ux').showMenuSidebar();
      }
    }
  }, [isLoading]);

  return isLoading ? (
    <></>
  ) : (
    <>
      <ProgressProvider>
        {isNavReshuffle ? (
          <ProductNavReshuffleProvider>
            <NavReshuffleContainer isCookiePolicyModalClosed={isCookiePolicyModalClosed}/>
          </ProductNavReshuffleProvider>
        ) : (
          <>
            <LegacyContainer isCookiePolicyModalClosed={isCookiePolicyModalClosed}/>
          </>
        )}
        <Suspense fallback="">
          <LiveChat
            closeLiveChat={() => shell.getPlugin('ux').closeChatbot()}
          />
        </Suspense>
        <Suspense fallback="">
          <AIChatbot />
        </Suspense>
      </ProgressProvider>

      <Suspense fallback="">
        <SSOAuthModal />
      </Suspense>
      <Suspense fallback="...">
        <CookiePolicy shell={shell} onValidate={cookiePolicyHandler} />
      </Suspense>
    </>
  );
}
